import * as Yup from 'yup'

export const projectManagersSchema = Yup.object({
  firstName: Yup.string().trim().required('First Name is required!'),
  lastName: Yup.string().trim().required('Last Name is required!'),
  email: Yup.string().email('Invalid Email!').required('Email is required!'),
})
